import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { Logo } from './Logo';
import { WhatsAppButton } from './WhatsAppButton';
import { QUOTE_MESSAGE } from '../utils/contact';
const navItems = [{
  label: 'Inicio',
  href: '#inicio'
}, {
  label: 'Portafolio',
  href: '#portafolio'
}, {
  label: 'Servicios',
  href: '#servicios'
}, {
  label: 'Acerca de mí',
  href: '#acerca'
}, {
  label: 'Contacto',
  href: '#contacto'
}];
export function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 16);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className={`fixed inset-x-0 top-0 z-50 transition-[background-color,border-color] duration-200 ease-out ${scrolled || open ? 'border-b border-white/10 bg-ink-950/90 backdrop-blur-xl' : 'border-b border-transparent bg-transparent'}`} data-id="element-115" data-mp="3bb651bu3h037">
      <div className="mx-auto flex max-w-page items-center justify-between gap-4 px-5 py-3 lg:px-8" data-id="element-116" data-mp="2rkq5x3y0wog2">
        <Logo data-id="element-117" data-mp="2mnpzut16bloy" />

        <nav aria-label="Navegación principal" className="hidden items-center gap-8 lg:flex" data-id="element-118" data-mp="2mn6sg695gfp6">
          {navItems.map(item => <a key={item.href} href={item.href} className="text-sm text-mist-muted transition-colors duration-200 ease-out hover:text-neon" data-id="element-119" data-mp="2hpy9w4k3a9ne">
              {item.label}
            </a>)}
        </nav>

        <div className="hidden lg:block" data-id="element-120" data-mp="35jy7u4lkmany">
          <WhatsAppButton message={QUOTE_MESSAGE} showIcon={false} data-id="element-121" data-mp="30mfve48chdb7">
            Solicitar Cotización
          </WhatsAppButton>
        </div>

        <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-controls="menu-movil" aria-label={open ? 'Cerrar menú' : 'Abrir menú'} className="grid h-10 w-10 place-items-center rounded-lg border border-white/15 text-mist transition-colors duration-200 ease-out hover:border-neon/60 hover:text-neon lg:hidden" data-id="element-122" data-mp="1xhc1ossslud">
          {open ? <XIcon className="h-5 w-5" aria-hidden="true" data-id="element-123" data-mp="1hlnpt2koebx3" /> : <MenuIcon className="h-5 w-5" aria-hidden="true" data-id="element-124" data-mp="1mljr2u1znp8y" />}
        </button>
      </div>

      {open ? <div id="menu-movil" className="border-t border-white/10 bg-ink-950/95 px-5 pb-6 pt-2 lg:hidden" data-id="element-125" data-mp="18lsbiovtq0su">
          <nav aria-label="Navegación móvil" className="flex flex-col" data-id="element-126" data-mp="1cmkj7dp1rxn0">
            {navItems.map(item => <a key={item.href} href={item.href} onClick={() => setOpen(false)} className="border-b border-white/5 py-3 text-sm text-mist transition-colors duration-200 ease-out hover:text-neon" data-id="element-127" data-mp="13nz3rrevgyqg">
                {item.label}
              </a>)}
          </nav>
          <WhatsAppButton message={QUOTE_MESSAGE} className="mt-5 w-full" size="md" showIcon={false} data-id="element-128" data-mp="mfg3umr67pfe">
            Solicitar Cotización
          </WhatsAppButton>
        </div> : null}
    </header>;
}